import React, { useContext, useEffect } from "react";
import Main from "../../components/main";
import { useQuery } from "../../utils/useQuery";
import ProgressSteps from "./ProgressSteps";
import { CheckListContext } from "../../utils/checkListContext";
import { useFetchChecklist } from "../../utils/useFetchChecklist";
import { API_BASE_URL, API_ROUTES } from "../../config";
import Loader from "../../components/Loader/Loader";

export default function UserNewCheckListTable() {
  const queryParams = useQuery();
  const product_id = queryParams.get("product_id");
  const userid = queryParams.get("userid");
  const product_Name = queryParams.get("product_name");
  const model_no = queryParams.get("model_no");
  const year = queryParams.get("year");
  const { setChecklistData } = useContext(CheckListContext);

  const [data, fetchdata, fetching, statusBE] = useFetchChecklist(
    `${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_CHECKLIST_QUESTIONS_ROUTE}`
  );

  useEffect(() => {
    if (statusBE) {
      setChecklistData(data?.data);
    }
  }, [data]);

  return (
    <>
      {fetching ? (
        <Loader />
      ) : (
        <>
          <Main>
            <span style={{ fontSize: "20px", fontWeight: "800" }}>
              {product_Name} {model_no} {year}
            </span>
            <span>
              <b>Product Id: {product_id}</b>
            </span>
            <span>
              <b>User Id: {userid}</b>
            </span>
          </Main>
          <ProgressSteps />
        </>
      )}
    </>
  );
}
